export const maybe = (defaultValue) => (data) => data || defaultValue;
